import { OrderStatus } from '@nx-customer-apps/shared/enums';
import { EnumDictionary } from '../types';

export const orderStatusDictionary: EnumDictionary<OrderStatus, string> = {
    [OrderStatus.Completed]: 'ORDER_STATUS.COMPLETED',
    [OrderStatus.Created]: 'ORDER_STATUS.CREATED',
    [OrderStatus.Processing]: 'ORDER_STATUS.PROCESSING',
    [OrderStatus.Rejected]: 'ORDER_STATUS.REJECTED'
};
